import { useRecoilValue } from "recoil";
import { outcomeCommentAtom } from "../miscellaneous/outcomeCommentAtom";

export const useOutcomeCommentValue = () => {
  return useRecoilValue(outcomeCommentAtom);
};
